import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { EndOfLifeClient } from './api';
import { techInsightsApiRef } from '@mercedes-benz/tech-insights-react';
import { endOfLifeApiRef } from '@mercedes-benz/endoflife-react';

/** @public */
export const endOfLifePlugin = createPlugin({
  id: 'endoflife',
  apis: [
    createApiFactory({
      api: endOfLifeApiRef,
      deps: {
        techInsightsApi: techInsightsApiRef,
      },
      factory({ techInsightsApi }) {
        return new EndOfLifeClient(techInsightsApi);
      },
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

/**
 * An extension
 * @public
 */
export const EntityEndOfLifeCard = endOfLifePlugin.provide(
  createRoutableExtension({
    name: 'EntityEndOfLifeCard',
    component: () =>
      import('./components/EndOfLifeCard/EndOfLifeCard').then(
        m => m.EndOfLifeCard,
      ),
    mountPoint: rootRouteRef,
  }),
);
